import React from 'react';
import PropTypes from 'prop-types';


const FormLabel = ({ children }) => {
  return (
    <label className={'pf-v5-c-form__label'}>
      <span className={'pf-v5-c-form__label-text'}>{ children }</span>
    </label>
  );
};

FormLabel.propTypes = {
  children: PropTypes.node
};

export default FormLabel;

